import React, { useCallback, useEffect, useState } from "react";

import { Button, makeStyles } from "@fluentui/react-components";

import { Chat24Filled, Dismiss24Regular } from "@fluentui/react-icons";
import FluentChatOverlayContainer from "./FluentChatOverlayContainer";
import { useCssBreakpoints } from "react-use-css-breakpoints";

const useStyles = makeStyles({
  button: {
    height: "40px",
    minWidth: "40px",
    backgroundColor: "rgba(22, 24, 30, 0.60)",
    "& span": {
      width: "24px",
      height: "24px",
      fontSize: "24px"
    },
    "& svg": {
      color: "#fff",
      fill: "#fff"
    }
  },
  buttonActive: {
    backgroundColor: "#16181E",
    height: "40px",
    minWidth: "40px",
    "& span": {
      width: "24px",
      height: "24px",
      fontSize: "24px"
    },
    "& svg": {
      color: "#fff",
      fill: "#fff"
    }
  }
});

export default function ToolbarChatButton({ toggleChat, isOpenChat, isOpenParticipants, selectedUser, closeChat, ...rest }) {
  const styles = useStyles();
  const breakpoint = useCssBreakpoints();

  return (
    <>
      <FluentChatOverlayContainer
        isOpenChat={isOpenChat}
        isOpenParticipants={isOpenParticipants}
        toggleChat={toggleChat}
        closeChat={closeChat}
        selectedUser={selectedUser}
        {...rest}
      ></FluentChatOverlayContainer>

      {!["xs", "sm", "md"].includes(breakpoint) && (
        <Button
          appearance="subtle"
          onClick={() => toggleChat(!isOpenChat)}
          className={isOpenChat ? styles.buttonActive : styles.button}
          icon={<Chat24Filled />}
        />
      )}
    </>
  );
}
